/** Compact columns; Qty is fixed so header + pills share one centered track. */
export const HIERARCHY_COLS = "minmax(140px, 1.2fr) minmax(140px, 1.2fr) minmax(100px, 0.9fr) 120px 40px";
export const HIERARCHY_CHEVRON_W = 18;
export const HIERARCHY_DEPTH_STEP = 14;
